window.addEventListener("load", function () {
  const targetButton = document.querySelector(
    "button[name='add'].product-form__submit"
  );

  if (targetButton) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes" || mutation.type === "childList") {
          const targetButtonText = targetButton.textContent.trim();
          if (targetButtonText == "Sold Out") {
            console.log("show BIS");
            document.querySelector(
              ".klaviyo-bis-trigger > button"
            ).style.display = "inline-flex";
          } else {
            console.log("hide BIS");
            document.querySelector(
              ".klaviyo-bis-trigger > button"
            ).style.display = "none";
          }
        }
      }
    });

    const config = { attributes: true, childList: true, subtree: true };

    observer.observe(targetButton, config);
  } else {
    console.warn("Target button not found!");
  }
});
